import React, { Component } from 'react';
import { LocaleContext } from '../locale-context';
import { BrowserRouter, Route, NavLink, Switch } from 'react-router-dom';
import Home from '../components/Home';
import Contact from '../components/Contact';
import MobileHeader from '../components/MobileHeader';
import Footer from '../components/Footer';
import Blog from '../components/Blog/Blog';
import News from '../components/News';
import Services from '../components/Services';
import Testimonials from '../components/Testimonials';
import AboutUs from '../components/AboutUs';
import BlogManagement from '../components/Blog/BlogManagement';
import { Container } from 'semantic-ui-react';
import SignInPage from '../components/SignIn';
import AuthUserContext from '../session/AuthUserContext';
import withAuthentication from '../session/withAuthentication';

class AppRouter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            preferredLocale: 'en'
        };
    }
    changeLanguage = ({ currentTarget: { id } }) => {
        this.setState({
            preferredLocale: id
        });
    };

    render() {
        return (
            <LocaleContext.Provider value={this.state.preferredLocale}>
                <BrowserRouter>
                    <div>
                        <MobileHeader changeLanguage={this.changeLanguage} />
                        <Switch>
                            <Route exact path="/" component={Home} />
                            <Route exact path="/blog" component={Blog} />
                            <Route
                                exact
                                path="/services"
                                component={Services}
                            />
                            <Route
                                exact
                                path="/testimonials"
                                component={Testimonials}
                            />
                            <Route exact path="/contact" component={Contact} />
                            <Route
                                exact
                                path="/signin"
                                component={() => <SignInPage />}
                            />
                            <AuthUserContext.Consumer>
                                {authUser =>
                                    authUser ? (
                                        <Container
                                            style={{
                                                marginTop: '8.5em',
                                                textAlign: 'center'
                                            }}
                                        >
                                            <Route
                                                exact
                                                path="/blogmanagement"
                                                component={BlogManagement}
                                            />
                                        </Container>
                                    ) : (
                                        ''
                                    )
                                }
                            </AuthUserContext.Consumer>
                        </Switch>
                        <Footer />
                    </div>
                </BrowserRouter>
            </LocaleContext.Provider>
        );
    }
}
export default withAuthentication(AppRouter);



// WEBPACK FOOTER //
// ./src/routers/index.js